import { Box, useTheme } from "@mui/material";
import { ControllerRenderProps } from "react-hook-form";

import { useTranslate } from "../../../../hooks/useTranslate";
import { TicketingPaymentInput } from "../../../../types/ticketing";
import { DonationPaymentInput } from "../../context/FormV2Context";

import { FormCheckbox } from "@/forms-design-system/FormCheckbox";
import { InvalidThemeErrorMessage } from "@/forms-design-system/InvalidThemeErrorMessage";

interface GiftAidCheckboxProps {
  field?: ControllerRenderProps<DonationPaymentInput | TicketingPaymentInput, "hasGiftAidConfirmation">;
  errorMessage?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const GiftAidCheckbox = ({ field, errorMessage, onChange }: GiftAidCheckboxProps) => {
  const theme = useTheme();
  const { t } = useTranslate();

  if (!theme.palette.forms || !theme.palette.formsComponents?.giftAidBlock) {
    return <InvalidThemeErrorMessage />;
  }

  return (
    <Box sx={{ display: "flex", alignItems: "flex-start", marginTop: theme.spacing(1) }}>
      <FormCheckbox
        {...field}
        checked={field?.value}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          field?.onChange(event);
          onChange?.(event);
        }}
        label={t("dashboard", "giftAidBlock.checkbox.label")}
        size="small"
        error={Boolean(errorMessage)}
        helperText={errorMessage}
      />
    </Box>
  );
};
